import React from 'react'
import { Divider, Select } from 'antd'
import { CustomTitle } from 'src/components'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import styles from './OffsetStepsOptionalKeysForm.module.scss'
import {
  offsetOptionalFieldsSelector,
  setOffsetOptionalField,
  offsetByExcelSelector,
} from 'src/features'

const OffsetStepsOptionalKeysForm: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { keys: excelKeys, offsetOptionalKeys } = useAppSelector(offsetByExcelSelector)
  const { fields: optionalFields } = useAppSelector(offsetOptionalFieldsSelector)

  return <>
    <Divider orientation='left' className='custom-divider'>
      <CustomTitle label={t('general.OptionalFields')} />
    </Divider>
    <div className='columns is-multiline'>
      {optionalFields.map((field, idx) => <div key={idx} className='column is-4'>
        <CustomTitle
          className={styles.title}
          label={t(`developers.OffSet.Fields.${field}`)}
        />
        <Select
          showSearch
          size='large'
          className='select-input'
          value={offsetOptionalKeys[field]}
          placeholder={t('developers.OffSet.SelectField')}
          onChange={(value: string) => dispatch(setOffsetOptionalField({ key: field, value }))}
        >
          {excelKeys.map((item, idx) => <Select.Option key={idx} value={item}>{item}</Select.Option>)}
        </Select>
      </div>)}
    </div>
  </>
}

export default OffsetStepsOptionalKeysForm
